export function errorMessageReducer(
  state: any = [],
  action: { type: string; payload: any }
) {
  switch (action.type) {
    case 'LOAD_ERROR_MESSAGE':
      state = action.payload;
      break;
    default:
      return state;
  }
  return Object.assign([], action.payload);
}
